import { isDown } from 'utils/mediaQuery';
import FormValidator from 'utils/form-validator';

export default class Footer {
  constructor() {
    this.accordionBtn = document.querySelectorAll('.accordion--btn');

    this.accordionBtn.forEach((button) => {
      button.addEventListener('click', this.toggleAccordion.bind(this));
    });

    new FormValidator(document.querySelector('.footer--newsletter form'), () => {
      console.log(arguments);
    });

    this.initAccessiBe();
  }

  toggleAccordion(e) {
    const target = e.target;
    const accordionPanel = target.nextElementSibling;
    const panelHeight = accordionPanel.style.maxHeight;
    const chevronSVG = target.querySelector('.chevron svg');
    const btnLink = target.closest('.accordion--btn').querySelector('.accordion--btn--link');

    if (target.classList.contains('accordion--btn--url') && btnLink != null) {
      btnLink.click();
    } else {
      if (chevronSVG != null) {
        chevronSVG.classList.toggle('show');
      };

      if (!isDown('sm')) return;

      if (!panelHeight || panelHeight === '0px') {
        accordionPanel.style.maxHeight = accordionPanel.scrollHeight + 'px';
      } else {
        accordionPanel.style.maxHeight = '0px';
      }
    }
  }

  initAccessiBe() {
    window.addEventListener('load', function() {
      setTimeout(() => {
        document.querySelectorAll('.footer--nav a').forEach(element => {
          if (element.getAttribute('href').indexOf('accessibility') >= 0){
            element.classList.add('link-accessibility');
          }
        });

        if (document.querySelector('.link-accessibility')) {
          document.querySelector('.link-accessibility').addEventListener('click', (e) => {
            e.preventDefault();

            document.querySelector('.acsb-trigger').click();
          })
        }
      }, 1000);
    })
  }
}


// $(window).on('load', function() {
//     $('.link-accessibility').on('click', function(event) {
//       event.preventDefault();
//       $('.acsb-trigger').trigger('click');
//     });
// });
